import { type NFTFormattedCollectibleDTO } from '@capsicum/common';

export type CollectiblePartner = {
	banner?: string;
	id?: string;
	logo?: string;
	name?: string;
	rewardsBackground?: string;
	shortCode?: string;
};

export type MyCollectible = NFTFormattedCollectibleDTO & {
	optionType?: string;
	partner?: CollectiblePartner;
	unlockingDate?: string;
	userParticipationId?: string;
};

export type MyCollectibles = {
	collectibles: Array<MyCollectible>;
	favoriteCollectibles: Array<MyCollectible>;
};

export enum CollectibleOwnerType {
	EXTERNAL = 'external',
	FAN = 'fan',
	NCW = 'ncw',
	PARTNER = 'partner',
	POOl = 'pool',
	RETAILER = 'retailer'
}
